import { render, staticRenderFns } from "./ConsultMessage.vue?vue&type=template&id=30ce4ea0&scoped=true&"
import script from "./ConsultMessage.vue?vue&type=script&lang=js&"
export * from "./ConsultMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultMessage.vue?vue&type=style&index=0&id=30ce4ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ce4ea0",
  null
  
)

export default component.exports